import { createSlice } from '@reduxjs/toolkit';
import { LABELGENAPI, LABELINGCHIMP_SAM_API, LABELINGCHIMP_LABEL_API } from '../../../API';
import axios from 'axios';

/* canceling previous requests if multiple requests is triggered */
const CancelToken = axios.CancelToken;
let source = CancelToken.source();

export const deliveriesslice = createSlice({
    name: 'deliveries',
    initialState: {
        deliveriesData: {
            data: [],
            loading: false,
            meta: {
                page: 1,
                per_page: 10,
                start_date: "",
                end_date: "",
                order_id: "",
                shipment_status: [],
                receiver_province: "",
                tracking_number: "",
                shippingchimp_manifest_number: "",
                carrier_name: [],
                customer_name: "",
                sorting: JSON.stringify([{
                    field: 'shipment.v.created_at',
                    sort: 'desc',
                  }])
            },
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        deliveriesColumns: {
            loading: false,
            notification: { show: false, messageContent: "", messageType: "success" }
        }
    },
    reducers: {
        getDeliveries: (state) => {
            return {
                ...state,
                deliveriesData: {
                    ...state.deliveriesData,
                    data: [],
                    loading: true
                }
            }
        },
        getDeliveriesSuccess: (state, action) => {
            return {
                ...state,
                deliveriesData: {
                    ...state.deliveriesData,
                    data: action && action.payload && action.payload.data && action.payload.data.data,
                    meta: action && action.payload && action.payload.data && action.payload.data.meta,
                    loading: false
                }
            }
        },
        getDeliveriesFailure: (state, action) => {
            return {
                ...state,
                deliveriesData: {
                    ...state.deliveriesData,
                    loading: false,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.message && [action.payload.data.message], messageType: "error" }
                }
            }
        },
        getDeliveriesColumn: (state) => {
            return {
                ...state,
                deliveriesColumns: {
                    ...state.deliveriesColumns,
                    loading: true
                }
            }
        },
        getDeliveriesColumnSuccess: (state, action) => {
            return {
                ...state,
                deliveriesColumns: {
                    ...state.deliveriesColumns,
                    loading: false,
                    columns: action && action.payload && action.payload.data && action.payload.data.data
                }
            }
        },
        getDeliveriesColumnFailure: (state, action) => {
            return {
                ...state,
                deliveriesColumns: {
                    ...state.deliveriesColumns,
                    loading: false,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.message && [action.payload.data.message], messageType: "error" }
                }
            }
        },
        postDeliveriesColumn: (state, action) => {
            return {
                ...state,
                deliveriesColumns: {
                    ...state.deliveriesColumns,
                    loading: true
                }
            }
        },
        postDeliveriesColumnSuccess: (state, action) => {
            return {
                ...state,
                deliveriesColumns: {
                    ...state.deliveriesColumns,
                    loading: false,
                    notification: { show: true, messageContent: [action.payload && action.payload.data && action.payload.data.message], messageType: "success" }
                }
            }
        },
        postDeliveriesColumnFailure: (state, action) => {
            return {
                ...state,
                deliveriesColumns: {
                    ...state.deliveriesColumns,
                    loading: false,
                    notification: { show: true, messageContent: [action.payload && action.payload.data && action.payload.data.message], messageType: "error" }
                }
            }
        },
        resetDeliveriessNotification: (state, action) => {
            return {
                ...state,
                deliveriesData: {
                    ...state.deliveriesData,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
                deliveriesColumns: {
                    ...state.deliveriesColumns,
                    notification: { show: false, messageContent: "", messageType: "success" }
                }
            }
        }


    }
})

export const { getDeliveries, getDeliveriesSuccess, getDeliveriesFailure } = deliveriesslice.actions;

export const doGetDeliveries = (meta) => dispatch => {

    const qs = Object.keys(meta)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(meta[key])}`)
        .join('&');

    dispatch(getDeliveries());
    try {
        source && source.cancel('Operation canceled due to new request.');
        source = axios.CancelToken.source();
        LABELGENAPI.get('/shipment/info?' + qs, {
            cancelToken: source.token
        }).then(function (response) {
            dispatch(getDeliveriesSuccess(response));
        })
            .catch(function (error) {
                if (!axios.isCancel(error)) {
                    dispatch(getDeliveriesFailure(error.response));
                }
            });
    } catch (error) {
        if (!axios.isCancel(error)) {
            dispatch(getDeliveriesFailure(error.response));
        }
    }
};


export const { getDeliveriesColumn, getDeliveriesColumnSuccess, getDeliveriesColumnFailure } = deliveriesslice.actions;

export const fetchDeliveriesColumns = () => {
    return (dispatch) => {
        dispatch(getDeliveriesColumn());
        try {
            LABELGENAPI
                .get('/shipment/columns')
                .then(function (response) {
                    dispatch(getDeliveriesColumnSuccess(response));
                })
                .catch(function (error) {
                    dispatch(getDeliveriesColumnFailure(error.response));
                });
        } catch (error) {
            dispatch(getDeliveriesColumnFailure());
        }
    };
};

export const { postDeliveriesColumn, postDeliveriesColumnSuccess, postDeliveriesColumnFailure } = deliveriesslice.actions;

export const saveDeliveriesColumns = (data) => {
    return (dispatch) => {
        dispatch(postDeliveriesColumn());
        try {
            LABELGENAPI
                .post('/shipment/columns', data)
                .then(function (response) {
                    dispatch(postDeliveriesColumnSuccess(response));
                    dispatch(fetchDeliveriesColumns());
                })
                .catch(function (error) {
                    dispatch(postDeliveriesColumnFailure(error.response));
                });
        } catch (error) {
            dispatch(postDeliveriesColumnFailure());
        }
    };
};

export const { resetDeliveriessNotification } = deliveriesslice.actions;

export const resetDeliveriessNotifications = () => {
    return (dispatch) => {
        dispatch(resetDeliveriessNotification());
    }
}

export default deliveriesslice.reducer;
